import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { GET_EMAIL_NOTIFICATIONS } from "../types";
import {
  getEmailNotificationsPending,
  getEmailNotificationsFulfilled,
  getEmailNotificationsRejected,
} from "../actions";

import { sendApiRequest, notifyError } from "../../../actions";

import generateError from "../../../utilities/generateError";

const createPayload = (payload) => ({
  method: "get",
  url: "emailnotification/all",
  onSuccess: [(response) => getEmailNotificationsFulfilled(response)],
  onError: [
    getEmailNotificationsRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const getEmailnotificationsEpic$ = (action$, state$) =>
  action$.pipe(
    ofType(GET_EMAIL_NOTIFICATIONS.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) => {
      return merge(
        of(getEmailNotificationsPending()),
        of(sendApiRequest(createPayload({ ...payload }), meta))
      );
    })
  );

export default getEmailnotificationsEpic$;



// WEBPACK FOOTER //
// ./src/features/organization/epics/getEmailNotificationsEpic.js